import React, { useEffect, useState } from "react";
import PartnerLogins from "../admin/companyPage/PartnerLogins";
import { useSelector } from "react-redux";
import httpRequest from "../../utils/Http";
import MainBody from "../../component/MainBody";

const PartnerAgent = () => {
  const user = useSelector((state) => state.authReducer.currentUser);
  const [partnerDetails, setPartnerDetails] = useState({});
  useEffect(() => {
    if (user.entity_id) {
      (async () => {
        const partners = await httpRequest(
          `getpartnerlist?partner_id=${user.entity_id}`,
          {},
          "GET"
        );
        console.log(partners.data["rows"]);
        if (
          partners.status === true &&
          partners.data &&
          partners.data["rows"].length > 0
        ) {
          const partner = partners.data["rows"][0];
          setPartnerDetails(partner);
        }
      })();
    }
  }, [user.entity_id]);
  return (
    <MainBody
      breadcrumbTitle="Agent"
      breadcrumbSubTitle={"Agent Logins"}
      navButton={""}
      title={""}
      component={
        <div>
          {user.entity_id && (
            <PartnerLogins
              partnerId={user.entity_id}
              role_id={user.role_id}
              partnerDetails={partnerDetails}
            />
          )}
        </div>
      }
    />
  );
};

export default PartnerAgent;
